import "./contactus.scss";
import "../../src-utilities/footer";
import "../../src-utilities/header";
import JustValidate from "../../../node_modules/just-validate/dist/just-validate.es";

const contactUsForm = document.querySelector(
  ".contact-us-form-wrapper #contact-us-form",
);

const contactUsFormData = new JustValidate(contactUsForm);

contactUsFormData
  .addField("#contact-firstname", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
    {
      rule: "customRegexp",
      value: /^(?=\S)([A-Za-z.]+(?:\s+[.A-Za-z]+){1,})$/,
      errorMessage: "Enter Valid Full Name",
    },
  ])
  .addField("#contact-company", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
  ])
  .addField("#contact-email", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      rule: "customRegexp",
      value:
        /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/,
      errorMessage: "Please enter a valid email",
    },
  ])
  .addField("#contact-category", [
    {
      rule: "required",
    },
  ])
  .addField("#contact-description", [
    {
      rule: "required",
    },
  ]);

let GoogleSendURL =
  "https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec";

let loader = document.querySelector(".loader");

contactUsForm.addEventListener("submit", async (event) => {
  event.preventDefault();
  if (contactUsFormData.isValid == false) {
    return false;
  }

  loader.classList.add("active");

  let formData = new FormData(event.target);
  let fullName = formData.get("lfirstname").split(" ");
  let firstName, lastName;
  [firstName, ...lastName] = fullName;
  lastName = lastName.join(" ");
  formData.set("lfirstname", firstName);
  formData.set("llastname", lastName);
  formData.append("sendurlvalue", window.location.href);
  formData.append("lsource", "Website Form - product contactus");

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  // Initiate the Sales IQ visitor data
  if (window.$zoho && window.$zoho.salesiq) {
    try {
      $zoho.salesiq.visitor.uniqueid();
      $zoho.salesiq.visitor.name(firstName + " " + lastName);
      $zoho.salesiq.visitor.email(formData.get("lemail"));
      console.log("SalesIQ Name/Email set");
    } catch (error) {
      console.warn("SalesIQ Error:", error);
    }
  }

  const raw = JSON.stringify({
    firstName: formData.get("lfirstname"),
    lastName: formData.get("llastname"),
    email: formData.get("lemail"),
    company: formData.get("lcompany"),
    description: formData.get("Description"),
    leadSource: formData.get("lsource"),
    interestedServices: formData.get("category"),
    websiteVisitURL: window.location.href,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const googleRequestOptions = {
    method: "GET",
    redirect: "follow",
  };

  let request = "?";
  [...formData].forEach(([key, value], index) => {
    request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
  });

  // Request 1: Main Backend
  const backendRequest = fetch(
    "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
    requestOptions,
  );

  // Request 2: Update the Google Sheet Data
  const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

  // Waiting until these request get's completed
  try {
    await Promise.allSettled([backendRequest, googleRequest]);
  } catch (e) {
    console.error("API Error", e);
  }

  // Redirect
  window.location.href = "https://products.cyntexa.com/success";
});
